<script setup lang="ts">
defineProps<{
	open: boolean;
}>();
</script>

<!-- Fades in over a `bar` header, covering its nearest positioned ancestor but leaving the header's bottom border visible. -->
<template>
	<Transition
		enter-active-class="transition-opacity ease-out duration-75"
		enter-from-class="opacity-0"
		enter-to-class="opacity-100"
		leave-active-class="pointer-events-none transition-opacity ease-in duration-75"
		leave-from-class="opacity-100"
		leave-to-class="opacity-0"
	>
		<div v-if="open" class="absolute inset-0 bottom-px z-10 flex items-center bg-default">
			<slot />
		</div>
	</Transition>
</template>
